export const getVisibleLfcDimensionsIds = (dimensions: any[], lfcDimensionsVisibilityJson: any[]): number[] =>
  dimensions.flatMap((dim) =>
    lfcDimensionsVisibilityJson.some(
      (ruleObj) => ruleObj.dimensionCode === dim.dimensionCode && ruleObj.visibility === 'VISIBLE'
    )
      ? [dim.dimensionId]
      : []
  )
